import baseApi from './baseApi'

export const categoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategory: builder.query({
      query: () => `/get_all_category`,
      transformResponse: (data) => {
        return Object.entries(data.get_cat).map(([id, category]) => ({ label: category, value: id }))
      },
      providesTags: ['categories'],
    }),
    addCategory: builder.mutation({
      query: ({ newCategory }) => ({
        method: 'POST',
        url: `/add_category`,
        body: { add_category: newCategory },
      }),
      invalidatesTags: ['categories'],
    }),
    deleteCategory: builder.mutation({
      query: ({ id }) => ({
        method: 'POST',
        url: `/delete_category`,
        body: { id_uid: id },
      }),
      invalidatesTags: ['categories'],
    }),
  }),
  overrideExisting: false,
})

// auto-generated based on the defined endpoints
export const { useGetCategoryQuery, useAddCategoryMutation, useDeleteCategoryMutation } = categoryApi
